import type { CSSObject } from '@emotion/react'
import { Color, OppositeTheme, Size } from '@opallabs/gem'
import { TabDirection } from './types'
import type { StyleProps } from './types'

export const container = ({ direction, theme }: StyleProps): CSSObject => ({
  backgroundColor:
    theme === 'light' ? Color[theme].Surface.N000 : Color[theme].Surface.N200,
  borderColor: Color[theme].Surface.N300,
  borderRadius: Size.Rounding,
  borderStyle: 'solid',
  borderWidth: 1,
  display: 'flex',
  flexDirection: direction === TabDirection.Column ? 'column' : 'row',

  '@media (prefers-contrast: more)': {
    borderColor: Color[OppositeTheme[theme]].Surface.N000,
  },
})
